import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

export interface EditableGridColumn {
  key: string;
  label: string;
  type: 'text' | 'select';
  options?: string[];
  guestOnly?: boolean;
  hideForGuest?: boolean;
}

@Component({
  selector: 'app-editable-grid',
  templateUrl: './editable-grid.component.html',
  styleUrls: ['./editable-grid.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
})
export class EditableGridComponent {

  @Input() columns: EditableGridColumn[] = [];
  @Input() rows: any[] = [];
  @Input() showSelectColumn: boolean = true;
  @Input() typeColumnKey: string = 'contactType';
  @Input() lowConfidenceMap: string = 'fieldConfidence';
  @Input() requiredFieldsByType: { [type: string]: string[] } = {};

  @Output() rowsChange = new EventEmitter<any[]>();
  @Output() selectionChange = new EventEmitter<any[]>();

  isAllSelected(): boolean {
    return this.rows.length > 0 && this.rows.every(r => r._include);
  }

  toggleSelectAll(event: any) {
    const checked = event.target.checked;
    this.rows.forEach(r => r._include = checked);
    this.emitSelection();
  }

  toggleSelectRow(row: any) {
    row._include = !row._include;
    this.emitSelection();
  }

  emitSelection() {
    this.selectionChange.emit(this.rows.filter(r => r._include));
    this.rowsChange.emit(this.rows);
  }

  onCellChange() {
    this.rowsChange.emit(this.rows);
  }

  isLowConfidence(row: any, key: string): boolean {
    const value = row[key];
    if (value === null || value === undefined || value === '') {
      return false;
    }
    const confidenceObj = row[this.lowConfidenceMap];
    const score = confidenceObj?.[key];
    return score !== undefined && score < 0.5;
  }

  // red-border check: is this column required for this row's contactType, and empty?
  isRequiredMissing(row: any, col: EditableGridColumn): boolean {
    const type = row[this.typeColumnKey];
    if (!type) {
      return false;
    }
    const requiredFields = this.requiredFieldsByType[type] || [];
    if (!requiredFields.includes(col.key)) {
      return false;
    }
    const value = row[col.key];
    return !value || !value.toString().trim();
  }
}